import "../styles/Loader.scss"

const Loader = () => {
  return (
    <div className='loader'>
      <div className='loader-inner'></div>
    </div>
  )
}

export default Loader